module.exports = "pegasus_template/assets/text_library_block.png";